import { gql } from '@apollo/client';

export const GET_REPORT_TEMPLATE = gql`
  query GetReportTemplate($templateId: ID!) {
    template: getReportTemplate(templateId: $templateId) {
      id
      name
      text
    }
  }
`;
